import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useStudentNotifications from '../../hooks/useStudentNotifications';
import '../../styles/notifications.css';

export default function StudentNotificationBell({ enabled = true }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);
  const { inbox, unreadCount, loadInbox, markRead, markAllRead } = useStudentNotifications({
    enabled,
  });

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const onToggle = async () => {
    const next = !open;
    setOpen(next);
    if (next) await loadInbox();
  };

  const onItemClick = async (item) => {
    if (!item.readAt) {
      try {
        await markRead([item.id]);
      } catch {
        /* ignore */
      }
    }
    setOpen(false);
    navigate('/student/notifications');
  };

  return (
    <div className="notif-bell-wrap" ref={wrapRef}>
      <button
        type="button"
        className="student-dash-menu-btn relative p-2 rounded-full"
        title="Notifications"
        aria-label="Notifications"
        aria-expanded={open}
        onClick={onToggle}
      >
        <span aria-hidden>🔔</span>
        {unreadCount > 0 ? (
          <span className="notif-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
        ) : null}
      </button>

      {open ? (
        <div className="notif-dropdown" role="menu">
          <div className="flex items-center justify-between px-2 py-1 mb-1">
            <strong style={{ fontSize: '0.85rem' }}>Notifications</strong>
            {unreadCount > 0 ? (
              <button type="button" className="notif-btn" style={{ padding: '0.2rem 0.5rem' }} onClick={markAllRead}>
                Mark all read
              </button>
            ) : null}
          </div>
          {inbox.length === 0 ? (
            <p className="notif-muted px-2 py-3">No notifications yet</p>
          ) : (
            inbox.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`notif-dropdown-item ${item.readAt ? '' : 'unread'}`}
                onClick={() => onItemClick(item)}
              >
                {item.subject || 'Notification'}
                <span className="notif-dropdown-meta">
                  {item.sentAt || item.createdAt
                    ? new Date(item.sentAt || item.createdAt).toLocaleString()
                    : ''}
                  {item.from ? ` · ${item.from}` : ''}
                </span>
              </button>
            ))
          )}
          <button
            type="button"
            className="notif-btn notif-btn-primary w-full mt-1"
            onClick={() => {
              setOpen(false);
              navigate('/student/notifications');
            }}
          >
            View all
          </button>
        </div>
      ) : null}
    </div>
  );
}
